import Vue from 'vue';
import PortalVue from 'portal-vue';
import VTooltip from 'v-tooltip';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { axios, constructUrl, errorToast, captureFatalError } from '@/utils';

// __E2E__ is injected by webpack's DefinePlugin in the E2E build, which arrives in a
// later backport PR (with the mock API + Playwright infra) to disable animations,
// Sentry, and toast delays so E2E runs focus purely on Playwright verification. Until
// that wiring lands __E2E__ is undefined, so the typeof guard keeps isE2E false in dev
// and production builds.
declare const __E2E__: boolean;
const isE2E = typeof __E2E__ !== 'undefined' && __E2E__;

Vue.use(PortalVue);
Vue.use(VTooltip);
Vue.use(Toast, {
	// vue-toastification's `transition` prop is String | Object (a Vue
	// transition name or class map), not Boolean. Disable the toast animation
	// in E2E via a 0ms duration so Playwright doesn't race the fade-out;
	// production keeps the default bounce at 750ms.
	transition: 'Vue-Toastification__bounce',
	transitionDuration: isE2E ? 0 : 750,
	maxToasts: 20,
	newestOnTop: true,
	position: 'top-center',
	timeout: isE2E ? 1000 : 5000,
	closeOnClick: true,
	pauseOnFocusLoss: true,
	pauseOnHover: true,
	draggable: !isE2E,
	draggablePercent: 0.6,
	hideCloseButton: false,
	hideProgressBar: false,
	icon: true
});
Vue.use(errorToast);

Vue.prototype.$axios = axios;
Vue.prototype.$constructUrl = constructUrl;
Vue.prototype.$captureFatalError = captureFatalError;

Vue.config.productionTip = false;
Vue.config.performance = true;

if (!isE2E) {
	Sentry.init({
		Vue,
		environment: window.location.hostname,
		dsn: 'https://01d12661b65d4016b18ee3204624924d@o1137879.ingest.sentry.io/6191130',
		logErrors: true,
		integrations: [Sentry.replayIntegration()],
		tracesSampleRate: 0.2
	});
}

if (isE2E) {
	document.body.classList.add('e2e');
}

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
